var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"skip"}},[(_vm.countdown > 0)?_c('span',[_vm._v(_vm._s(_vm.countdown)+" "+_vm._s(_vm.$t("CONTENT.AD")))]):(_vm.loaded)?_c('span',{on:{"click":function($event){return _vm.skip()}}},[_vm._v("\n    "+_vm._s(_vm.$t("CONTENT.AD-SKIP"))+"\n    "),_c('icon',{attrs:{"name":"step-forward","scale":1.2}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce84cd04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdCounter.vue
// module id = null
// module chunks = 